export const heritageTheme = {
  dark: false,
  colors: {
    background: '#F7F9F7', surface: '#FFFFFF', 'surface-bright': '#FFFFFF', 'surface-light': '#F2F5F2',
    'surface-variant': '#E8F2EE', 'on-surface-variant': '#405258', 'on-background': '#142528', 'on-surface': '#142528',
    primary: '#0F5E57', 'primary-darken-1': '#0A3D39', 'on-primary': '#FFFFFF',
    secondary: '#D79A38', 'on-secondary': '#142528', 'secondary-darken-1': '#B97B22',
    error: '#A62936', info: '#347B92', success: '#0F5E57', warning: '#886012',
  },
};
